module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"registerLabel":"Enter your user information"},"ko":{"registerLabel":"회원 정보 입력"}}')
  delete Component.options._Ctor
}
